import ProductProfilesTab from './ProductProfilesTab';

export default ProductProfilesTab;
